(function() {
  async function removeZeroPriceCPBproductsFromCart() {
    const result = await fetch('/cart.js');
    const json = await result.json();
    const zeroCPBItems = json.items.filter(item => item.price === 0 && item.product_type.includes('cpb_'));
    let updates = {};
    zeroCPBItems.forEach(item => {
      updates[item.variant_id] = 0;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({updates})
    });
  }
  removeZeroPriceCPBproductsFromCart();
})();